import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { UserContext } from "contexts/UserContext";

import Chip from "components/Chip";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HikingWalkingIcon from "assets/icons/trailcard/DeTour ICO Sets_Trailhead.png";
import HuntingFishingIcon from "assets/icons/trailcard/DeTour ICO Sets_Hunting.png";
import MultiUseIcon from "assets/icons/trailcard/DeTour ICO Sets_Multi-Use.png";
import HorseIcon from "assets/icons/trailcard/Detour Icon Sets_Horse.png";
import AtvIcon from "assets/icons/trailcard/Detour Icon Sets-56.png";
import BicycleIcon from "assets/icons/trailcard/MountainBiking.png";
import SkiingIcon from "assets/icons/trailcard/Detour Icon Sets_Cross country.png";
import SnowmobilesIcon from "assets/icons/trailcard/Detour Icon Sets_Snow mobile.png";

import NoImage from "assets/icons/trailcard/NoImage.svg";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import AddIcon from "@material-ui/icons/Add";
import LoginRequiredAlert from "components/TrailCard/LoginRequiredAlert";
import SubmittedPhotoAlert from "components/TrailCard/SubmittedPhotoAlert";
import renderHTML from "react-render-html";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import esriRequest from "@arcgis/core/request";

// const photoTableUrl = 'https://gis.ohiodnr.gov/arcgis_site2/rest/services/OIT_Services/Ohio_DETOUR_trails_test/MapServer/15';
const userSubmittedPhotosUrl =
  "https://services.arcgis.com/KaUCf2c6ny3gxeuY/arcgis/rest/services/UserSubmittedPhotos/FeatureServer/0";
const fldPhotoTrailName = "TrailName";
const fldPhotoManagedAreaName = "ManagedAreaName";
const fldPhotoUsername = "Username";
const fldPhotoLongitude = "Longitude";
const fldPhotoLatitude = "Latitude";

const useStyles = makeStyles({
  root: {
    display: "flex",
    border: "none",
    boxShadow: "none",
  },
  media: {
    height: 150,
    backgroundSize: "cover",
    backgroundBlendMode: "screen",
    filter: "brightness(70%)",
  },
  overlayTrail: {
    width: "26vw",
    color: "white",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    fontSize: "20px",
    lineHeight: "24px",
    letterSpacing: "0.25px",
    overflow: "hidden",
    whiteSpace: "break-spaces",
  },
  overlayManageArea: {
    color: "white",
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
  },
  infoFlex: {
    position: "absolute",
    top: "100px",
    left: "10px",
  },
  flexBox: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
  },
  nearbyTrailsFlex: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "17px",
    letterSpacing: "0.25px",
    textAlign: "left",
  },
  favoriteAndDirectionsFlex: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    height: "32px",
    marginBottom: "10px",
    marginTop: "8px",
  },
  distance: {
    fontWeight: "600",
    lineHeight: "20px",
    fontSize: "14px",
    letterSpacing: "0.25px",
    /* identical to box height, or 143% */
  },
  trailConfiguration: {
    fontWeight: "300",
    lineHeight: "20px",
    fontSize: "14px",
    letterSpacing: "0.25px",
  },
  difficulty: {
    fontFamily: "Open Sans",
    background: "#D1E9CB",
    borderRadius: "16px",
    width: "54px",
    height: "24px",
    textAlign: "center",
    marginLeft: "15px",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#222222",
  },
  fee: {
    fontWeight: "600",
    marginLeft: "auto",
    marginRight: "10px",
  },
  iconFlex: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    marginTop: "12px",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    gap: "10px",
    justifyContent: "flex-start",
  },
  favIcon: {
    backgroundSize: "contain",
    color: "white",
    height: "18.5px",
    width: "20px",
    top: "13px",
    left: "13px",
    position: "absolute",
  },
  imgFlex: {
    display: "flex",
  },
  trailType: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19.2px",
    letterSpacing: "0.25px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    justifySelf: "flex-start",
    flexGrow: "1",
    display: "inline-flex",
  },
  difficultyChip: {
    justifySelf: "flex-end",
  },
  managerFlex: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    marginTop: "10px",
  },
  managerAttr: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.25px",
    marginTop: "4px",
  },
  websiteAttr: {
    marginTop: "10px",
    color: "#4D7343",
  },
  managerTitle: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "300",
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.25px",
  },
  distanceSurfaceFlex: {
    display: "flex",
    flexDirection: "row",
    fontFamily: "Open Sans",
    fontSize: "14px",
    lineHeight: "20px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    marginTop: "8px",
    justifyContent: "space-between",
  },
  favoriteFlex: {
    display: "flex",
    flexDirection: "column",
    color: "#4D7343",
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    alignItems: "center",
    marginLeft: "15px",
    cursor: "pointer",
  },
  directionsFlex: {
    display: "flex",
    flexDirection: "column",
    color: "#4D7343",
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    alignItems: "center",
    height: "25px",
  },
  descriptionText: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "17px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    textAlign: "left",
    mixBlendMode: "normal",
    margin: "24px 0",
  },
  customNotes: {
    fontFamily: "Open Sans",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "19.6px",
    letterSpacing: "0.25px",
    color: "#4D4D4D",
    textAlign: "left",
    mixBlendMode: "normal",
    margin: "24px 0",
  },
  nearbyTrails: {
    color: "#4D4D4D",
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "19.2px",
    letterSpacing: "0.25px",
    flexGrow: "1",
    display: "inline-flex",
    marginTop: "2rem",
  },
  noPointer: {
    cursor: "default",
  },
  backArrow: {
    backgroundSize: "contain",
    color: "white",
    height: "24.5px",
    width: "28px",
    top: "13px",
    left: "13px",
    position: "absolute",
    cursor: "pointer",
  },
  huntingFishingIcon: {
    backgroundImage: `url(${HuntingFishingIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  hikingWalkingIcon: {
    backgroundImage: `url(${HikingWalkingIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  multiUseIcon: {
    backgroundImage: `url(${MultiUseIcon})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  bicycleIcon: {
    backgroundImage: `url(${BicycleIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  horseIcon: {
    backgroundImage: `url(${HorseIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  snowmobilesIcon: {
    backgroundImage: `url(${SnowmobilesIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  atvIcon: {
    backgroundImage: `url(${AtvIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  skiingIcon: {
    backgroundImage: `url(${SkiingIcon})`,
    backgroundSize: "contain",
    height: "20px",
    width: "20px",
  },
  thumbnailsFlex: {
    display: "inline-flex",
    flexWrap: "wrap",
    width: "calc(100% + 12px)",
    marginTop: "8px",
  },
  thumbnail: {
    height: "120px",
    width: "120px",
    margin: "4px",
    cursor: "pointer",
    backgroundSize: "cover",
    backgroundBlendMode: "screen",
    "&:hover": {
      boxShadow: "1px 1px 5px 0px #999",
    },
  },
  addButton: {
    height: "60px",
    width: "60px",
    margin: "4px",
    cursor: "pointer",
    background: "#EAEAEA",
  },
  addButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "120px",
    width: "120px",
    margin: "4px",
    cursor: "pointer",
    background: "#EAEAEA",
    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "1px 1px 5px 0px #999",
    },
  },
  photoInput: {
    display: "none",
  },
  accordian: {
    paper: {
      boxShadow: "none",
    },
  },
});

const difficulties = {
  Easiest: "Easiest",
  Easy: "Easy",
  MoreDiff: "Moderate",
  VeryDiff: "Difficult",
  ExtmDiff: "Extreme",
  NA: "Not Assessed",
};

const imgAttrs = ["IMG_URL1", "IMG_URL2", "IMG_URL3", "IMG_URL4", "IMG_URL5"];

export default function FeaturedRouteDetails({
  attributes,
  setSidebarSelection,
  nearbyTrails,
}) {
  const classes = useStyles();
  const { userInfo } = useContext(UserContext);
  const [favorite, setFavorite] = useState(null);
  const [loginRequiredAlertOpen, setloginRequiredAlertOpen] = useState(false);
  const [submittedPhotoAlertOpen, setSubmittedPhotoAlert] = useState(false);
  const [photoIndex, changePhotoIndex] = useState(0);
  const [photoGalOpen, changePhotoGalOpen] = useState(false);
  const [photos, setPhotos] = useState([]);
  const history = useHistory();
  const hiddenPhotoInput = React.useRef(null);

  useEffect(() => {
    //Get favorites on initial load
    if (userInfo) {
      (async () => {
        let res = await esriRequest(userInfo.favoritesUrl + "/query", {
          method: "post",
          query: {
            where: `TrailID = ${attributes.PRIMARY_TRAIL_ID} AND IsFeaturedTrail = 1`,
            f: "json", // format
          },
        });
        if (res && res.data.features && res.data.features.length) {
          setFavorite(true);
        } else {
          setFavorite(false);
        }
      })();
    }

    setPhotos(
      Object.entries(attributes)
        .filter(([attr, val]) => imgAttrs.includes(attr) && val)
        .map(([attr, val]) => val)
    );
  }, [attributes]);

  useEffect(() => {
    //Get favorites if user logs in
    if (userInfo) {
      (async () => {
        let res = await esriRequest(userInfo.favoritesUrl + "/query", {
          method: "post",
          query: {
            where: `TrailID = ${attributes.PRIMARY_TRAIL_ID} AND IsFeaturedTrail = 1`,
            f: "json", // format
          },
        });
        if (res && res.data.features && res.data.features.length) {
          setFavorite(true);
        } else {
          setFavorite(false);
        }
      })();
    }
  }, [userInfo]);

  useEffect(() => {
    (async () => {
      if (userInfo) {
        if (favorite === true && userInfo && userInfo.favoritesUrl) {
          esriRequest(userInfo.favoritesUrl + "/applyEdits", {
            method: "post", // POST request
            query: {
              adds: JSON.stringify([
                {
                  attributes: {
                    TrailID: attributes.PRIMARY_TRAIL_ID,
                    IsFeaturedTrail: 1,
                  },
                },
              ]),
              f: "json", // format
            },
          });
        } else if (favorite === false) {
          const layer = new FeatureLayer({
            url: userInfo.favoritesUrl,
          });
          let query = layer.createQuery();
          query.where = `TrailID = '${attributes.PRIMARY_TRAIL_ID}'`;
          query.outFields = ["OBJECTID"];
          layer.queryFeatures(query).then((r) => {
            const objectIds = r.features.map(
              (feature) => feature.attributes.OBJECTID
            );
            esriRequest(userInfo.favoritesUrl + "/applyEdits", {
              method: "post", // POST request
              query: {
                deletes: JSON.stringify(objectIds),
                f: "json", // format
              },
            });
          });
        }
      }
    })();
    //update user's favorite trails/routes
  }, [favorite]);

  const gotoDetails = () => {
    setSidebarSelection(null);
    history.push("/details");
  };

  const primaryTypes = {
    HikeWalk: "Hiking/Walking Trail",
    MultiUse: "Multi-use",
    Motorized: "Motorized Trail",
    MntnBike: "Mountain Biking Trail",
    Snowmobile: "Snowmobiling Trail",
    Equestrian: "Equestrian Trail",
    XCountrySki: "Cross-country Ski Trail",
    HuntFishAccess: "Hunting/Fishing Access Trail",
  };

  const primaryTypeIcon = {
    HikeWalk: "hikingWalkingIcon",
    MultiUse: "multiUseIcon",
    Motorized: "atvIcon",
    MntnBike: "bicycleIcon",
    Snowmobile: "snowmobilesIcon",
    Equestrian: "horseIcon",
    XCountrySki: "skiingIcon",
    HuntFishAccess: "huntingFishingIcon",
  };

  const configuration = {
    Loop: "Loop",
    OutBack: "Out and Back",
    Linear: "Linear",
    NA: "Not assessed",
    "Not assessed": "NA",
  };

  const isValid = (attr) => {
    const allowedVals = ["Recmnd", "Partial"];
    return allowedVals.includes(attr);
  };

  const anyAttributes = () => {
    const allowedVals = ["Recmnd", "Partial"];
    const attrs = [
      attributes.DOGS,
      attributes.HORSES,
      attributes.SNOWMOBILES,
      attributes.BIKES,
      attributes.XC_SKIING,
      attributes.OFF_ROAD_4X4,
      attributes.WHEELCHAIR_FRIENDLY,
    ];
    return attrs.some((attr) => allowedVals.includes(attr));
  };

  const getDescription = () => {
    if (attributes.DESCRIPTION !== null && attributes.DESCRIPTION.length)
      return (
        <>
          <Accordion defaultExpanded={true} elevation={0}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            ></AccordionSummary>
            <AccordionDetails>
              <Typography class={classes.descriptionText}>
                {renderHTML(attributes.DESCRIPTION)}
              </Typography>
            </AccordionDetails>
          </Accordion>
        </>
      );
  };

  const getFavorite = () => {
    if (favorite) {
      return (
        <div class={classes.favoriteFlex}>
          <FavoriteIcon onClick={() => setFavorite(false)} />
          Favorited
        </div>
      );
    } else if (!favorite) {
      return (
        <div class={classes.favoriteFlex}>
          <FavoriteBorderIcon onClick={() => setFavorite(true)} />
          Favorite
        </div>
      );
    }
    return null;
  };

  const launchGallery = (index, changePhotoIndex, changePhotoGalOpen) => {
    changePhotoIndex(index);
    changePhotoGalOpen(true);
  };

  const handlePhotoInputClick = (event) => {
    if (!userInfo) {
      setloginRequiredAlertOpen(true);
    } else {
      hiddenPhotoInput.current.click();
    }
  };

  const handlePhotoInputChange = (event) => {
    // if(!userInfo){
    //   alert(userNotLoggedInAlertMsg)
    //   return;
    // }
    let file = event.target.files[0];
    //Send file to table
    (async () => {
      try {
        let attr = {};

        attr[fldPhotoTrailName] = attributes.PRIMARY_NAME;
        attr[fldPhotoManagedAreaName] = attributes.MANAGED_AREA_NAME;
        attr[fldPhotoUsername] = userInfo.user.username;
        attr[fldPhotoLongitude] = null;
        attr[fldPhotoLatitude] = null;

        let userLocation = await getLocation();
        let point = new Point({
          x: userLocation.coords.longitude,
          y: userLocation.coords.latitude,
        });

        const userSubmittedPhotosLayer = new FeatureLayer({
          url: userSubmittedPhotosUrl,
        });
        userSubmittedPhotosLayer.load().then(async () => {
          const addFeature = new Graphic({
            geometry: point,
            attributes: attr,
          });

          const res = await userSubmittedPhotosLayer.applyEdits({
            addFeatures: [addFeature],
          });

          if (
            res &&
            res.addFeatureResults &&
            res.addFeatureResults.length &&
            res.addFeatureResults[0].objectId
          ) {
            const objectId = res.addFeatureResults[0].objectId;
            addFeature.attributes.OBJECTID = objectId;

            const form = new FormData();
            form.set("attachment", file);
            form.append("f", "json");
            userSubmittedPhotosLayer
              .addAttachment(addFeature, form)
              .then(function (result) {
                console.log(
                  "Thank you for your photo submission. It will be reviewed shortly.",
                  result
                );
                setSubmittedPhotoAlert(true);
              })
              .catch(function (err) {
                console.log("attachment adding failed: ", err);
                throw new Error(
                  "Error encountered while attempting to upload image"
                );
              });
          }
        });
      } catch (e) {
        alert("Error encountered while attempting to upload image");
      }
    })();
  };

  const getLocation = () => {
    return new Promise((res, rej) => {
      var geolocation = navigator.geolocation;
      geolocation.getCurrentPosition(
        (position) => {
          res(position);
        },
        (err) => {
          rej(err);
        }
      );
    });
  };

  const getPhotoGallery = () => {
    // console.log(photos);
    return (
      <div className={classes.managerFlex}>
        <div className={classes.managerTitle}>Trail Photos</div>
        <div className={classes.thumbnailsFlex}>
          {photos.map((photo, index) => (
            <div
              key={index}
              className={classes.thumbnail}
              style={{ backgroundImage: `url(${photo})` }}
              onClick={(e) =>
                launchGallery(index, changePhotoIndex, changePhotoGalOpen)
              }
            />
          ))}
          <div
            className={classes.addButtonContainer}
            onClick={handlePhotoInputClick}
          >
            <input
              type="file"
              accept="image/*"
              onChange={handlePhotoInputChange}
              ref={hiddenPhotoInput}
              className={classes.photoInput}
            />
            <AddIcon className={classes.addButton} />
          </div>
        </div>
        <LoginRequiredAlert
          loginAlertOpen={loginRequiredAlertOpen}
          setLoginRequiredAlertClose={handleLoginRequiredAlertClose}
        />
        <SubmittedPhotoAlert
          submittedPhotoAlertOpen={submittedPhotoAlertOpen}
          submittedPhotoAlertClose={handleSubmittedPhotoAlertClosed}
        />
      </div>
    );
  };

  const handleLoginRequiredAlertClose = () => {
    setloginRequiredAlertOpen(false);
  };

  const handleSubmittedPhotoAlertClosed = () => {
    setSubmittedPhotoAlert(false);
  };

  const fixUrl = (url) => {
    if (url && url.charAt(url.length - 1) === "/") {
      return url.slice(0, -1);
    } else {
      return url;
    }
  };

  return (
    <Card className={classes.root}>
      <CardActionArea className={classes.noPointer}>
        <CardMedia
          className={classes.media}
          image={photos.length ? photos[0] : NoImage}
          title="Trail Card"
        />
        <div class={classes.imgFlex}>
          <ArrowBackIcon
            classes={{ root: classes.backArrow }}
            onClick={() => {
              gotoDetails();
            }}
          ></ArrowBackIcon>
          <Chip type="Featured Route"></Chip>
        </div>
        <div class={classes.infoFlex}>
          <div class={classes.overlayTrail}>{attributes.FeaturedRoute}</div>
        </div>
        {userInfo ? (
          <div class={classes.favoriteAndDirectionsFlex}>{getFavorite()}</div>
        ) : null}
        <CardContent>
          <div class={classes.flexBox}>
            <div class={classes.trailType}>
              <span>{primaryTypes[attributes.PRIMARY_TYPE]}</span>
              <div
                class={classes[primaryTypeIcon[attributes.PRIMARY_TYPE]]}
                style={{ marginLeft: "8px" }}
              ></div>
            </div>

            <Chip
              class={classes.difficultyChip}
              type="Difficulty"
              trailDifficulty={
                attributes.DIFFICULTY
                  ? difficulties[attributes.DIFFICULTY]
                  : "Not Assessed"
              }
            ></Chip>
          </div>
          <div class={classes.distanceSurfaceFlex}>
            <div class={classes.managerFlex}>
              <div class={classes.managerTitle}>Length</div>
              <div class={classes.managerAttr}>
                <span class={classes.distance}>
                  {Math.round(10 * (attributes.Length_SPC / 5280)) / 10 > 0.1
                    ? Math.round(10 * (attributes.Length_SPC / 5280)) / 10
                    : "< 0.1"}{" "}
                  mi
                </span>
                {attributes.CONFIGURATION ? (
                  <span> ({configuration[attributes.CONFIGURATION]})</span>
                ) : null}
              </div>
            </div>
          </div>
          {getDescription()}
          <div class={classes.distanceSurfaceFlex}>
            <div class={classes.managerFlex}>
              <div class={classes.managerTitle}>Minimum Elevation</div>
              <div class={classes.managerAttr}>
                <span class={classes.distance}>
                  {Math.round(attributes.MIN_ELEV)} ft
                </span>
              </div>
            </div>
            <div class={classes.managerFlex}>
              <div class={classes.managerTitle}>Maximum Elevation</div>
              <div class={classes.managerAttr}>
                <span class={classes.distance}>
                  {Math.round(attributes.MAX_ELEV)} ft
                </span>
              </div>
            </div>
          </div>
          {attributes.WEBSITE_URL ? (
            <div class={classes.websiteAttr}>
              <a
                href={fixUrl(attributes.WEBSITE_URL)}
                class={classes.distance}
                style={{ color: "inherit" }}
                target="_blank"
                rel="noreferrer"
              >
                Website
              </a>
            </div>
          ) : null}
          {getPhotoGallery()}
          {photoGalOpen ? (
            <Lightbox
              mainSrc={photos[photoIndex]}
              nextSrc={photos[(photoIndex + 1) % photos.length]}
              prevSrc={photos[(photoIndex + photos.length - 1) % photos.length]}
              onCloseRequest={() => changePhotoGalOpen(false)}
              onMovePrevRequest={() =>
                changePhotoIndex(
                  (photoIndex + photos.length - 1) % photos.length
                )
              }
              onMoveNextRequest={() =>
                changePhotoIndex((photoIndex + 1) % photos.length)
              }
            />
          ) : null}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
